// extracted by mini-css-extract-plugin
export var falconContainer = "_vl-2";
export var offerCenter = "_vl-0";
export var roktContainer = "_vl-1";